/**
 * Converts FastAPI/Pydantic `response.data.detail` into plain text for alerts/UI.
 * `detail` may be a string, a single object with `msg`, or an array of validation errors.
 */
export function formatApiDetail(detail) {
  if (detail == null || detail === '') return '';
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    const parts = detail
      .map((item) => {
        if (!item) return '';
        if (typeof item === 'string') return item;
        if (typeof item === 'object' && typeof item.msg === 'string') {
          const field = Array.isArray(item.loc) ? item.loc.filter((x) => x !== 'body').join('.') : '';
          return field ? `${field}: ${item.msg}` : item.msg;
        }
        return '';
      })
      .filter(Boolean);
    return parts.length ? parts.join('. ') : '';
  }
  if (typeof detail === 'object') {
    if (typeof detail.msg === 'string' && detail.msg.trim()) return detail.msg;
    if (typeof detail.message === 'string' && detail.message.trim()) return detail.message;
  }
  return '';
}

/** Pull production choices from a multiple_productions API error, if present. */
export function projectsFromApiError(err) {
  const raw = err?.response?.data?.detail;
  if (raw && typeof raw === 'object' && Array.isArray(raw.projects) && raw.projects.length) {
    return raw.projects;
  }
  if (typeof raw === 'string') {
    try {
      const parsed = JSON.parse(raw);
      if (parsed && typeof parsed === 'object' && Array.isArray(parsed.projects) && parsed.projects.length) {
        return parsed.projects;
      }
    } catch {
      /* ignore */
    }
  }
  return null;
}

export function isMultipleProductionsError(err) {
  const raw = err?.response?.data?.detail;
  if (raw && typeof raw === 'object' && raw.code === 'multiple_productions') return true;
  if (Array.isArray(raw?.projects) && raw.projects.length > 1) return true;
  const text = typeof raw === 'string'
    ? raw
    : typeof raw?.message === 'string'
      ? raw.message
      : '';
  return /more than one production/i.test(text);
}
